import React from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';

/* helpers */
import {getClassName} from '../../../helpers/dom-helpers';
/* components */
import Portal from '../portal';
import MenuItem from './menu-item/menu-item';
import SubMenu from './sub-menu/sub-menu';
import Tooltip from 'rc-tooltip';
/* styles */
import './menu.scss';

class Menu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.menuToogleRef = React.createRef();
    this.itemsRef = React.createRef();

    this.state = {
      itemsVisible: false,
    };
  }

  getChildContext() {
    return {
      toggleMenu: this.toggleItems,
    };
  }

  componentDidMount() {
    document.addEventListener('scroll', this.closeItemsOnScroll, true);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.closeItemsOnScroll, true);
  }

  closeItemsOnClickOutside = (e) => {
    if (this.state.itemsVisible && !this.itemsRef.current.contains(e.target)) {
      this.toggleItems();
    }
  };

  closeItemsOnScroll = () => {
    if (this.state.itemsVisible) {
      this.toggleItems();
    }
  };

  toggleItems = () => {
    this.setState((state) => {
      const newState = {
        ...state,
      };

      newState.itemsVisible = !state.itemsVisible;

      return newState;
    });
  };

  handleMenuToggleClick = (e) => {
    if (this.props.isDisabled) {
      return;
    }

    e.stopPropagation();

    this.toggleItems(true);
  };

  renderItems() {
    let collapseDown = this.props.collapseDown;
    let boundingBox = null;
    const menuTooltipWidth = 220;
    if (this.menuToogleRef.current) {
      boundingBox = this.menuToogleRef.current.getBoundingClientRect();
      if (boundingBox.top < window.innerHeight / 2) {
        collapseDown = true;
      }
    }
    let boundingBoxLeft = boundingBox.left;
    if (boundingBoxLeft < menuTooltipWidth) {
      boundingBoxLeft += 250;
    }
    const menuItemsClass = getClassName('glu-menu__items', this.props.itemsClassName, {
      'glu-menu__items--visible': this.state.itemsVisible,
      'glu-menu__items--right': this.props.menuRight,
      'glu-menu__items--collapse-down': collapseDown,
    });
    const className = !this.props.children.some((child) => child && child.props.icon)
      ? 'glu-menu--no-icons'
      : '';

    return (
      <Portal>
        <OutsideClickHandler onOutsideClick={this.closeItemsOnClickOutside}>
          <div
            className={className}
            style={{
              position: 'fixed',
              left: boundingBox ? boundingBoxLeft : 0,
              top: boundingBox ? boundingBox.top : 0,
              zIndex: 9999,
            }}
            ref={this.itemsRef}
          >
            <div className={`${menuItemsClass} ${this.props.customClass}`}>
              {this.props.children}
            </div>
          </div>
        </OutsideClickHandler>
      </Portal>
    );
  }

  render() {
    const menuClass = getClassName('glu-menu', this.props.className, {
      'glu-menu--active': this.state.itemsVisible,
      'glu-menu--disabled': this.props.isDisabled,
    });

    return (
      <button className="glu-btn-link glu-tooltip">
        <div className={menuClass}>
          <Tooltip
            placement="top"
            trigger={['hover']}
            overlay={<span>{this.props.tooltipLabel}</span>}
          >
            <span
              ref={this.menuToogleRef}
              className={`glu-menu__icon g-icon g-icon-${this.props.menuIcon}`}
              onClick={this.handleMenuToggleClick}
            />
          </Tooltip>
          {this.state.itemsVisible && this.renderItems()}
        </div>
      </button>
    );
  }
}

Menu.childContextTypes = {
  toggleMenu: PropTypes.func.isRequired,
};

Menu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  collapseDown: PropTypes.bool,
  isDisabled: PropTypes.bool,
  itemsClassName: PropTypes.string,
  menuRight: PropTypes.bool,
  menuIcon: PropTypes.string,
  tooltipLabel: PropTypes.string,
};

Menu.defaultProps = {
  children: null,
  className: '',
  collapseDown: false,
  isDisabled: false,
  itemsClassName: '',
  menuRight: false,
  menuIcon: 'more',
  tooltipLabel: 'View more',
  onClick: undefined,
  stopPropagation: false,
};

export {MenuItem, SubMenu};

export default Menu;
